import * as Yup from "yup";

interface IOption {
  [key: string]: string | number;
}
type ITFunction = (key: string, options?: IOption) => string;

const InfoEditValidationSchema = (t: ITFunction) =>
  Yup.object().shape({
    displayName: Yup.string()
      .required(t("sso:validation.required"))
      .max(20, t("sso:validation.display.name", { key: 20 })),
    authenticationEndpoint: Yup.string().required(t("sso:validation.required")),
    identityProviderEntityID: Yup.string().required(
      t("sso:validation.required"),
    ),
    publicCertificate: Yup.string().required(t("sso:validation.required")),
  });

export default InfoEditValidationSchema;
